import { useGetList, useTranslate } from "ra-core";
import { TriangleAlert } from "lucide-react";

import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { contactOptionText } from "@/components/atomic-crm/misc/ContactOption";

// Person or organization holding the rackets, inside an ra-core Form
// (contact_id, company_id)
export const HolderFields = () => {
  const translate = useTranslate();
  return (
    <div className="grid gap-3 md:grid-cols-2">
      <ReferenceInput source="contact_id" reference="contacts_summary">
        <AutocompleteInput
          label={translate("tenax.rackets.fields.contact_id")}
          optionText={contactOptionText}
          helperText={false}
        />
      </ReferenceInput>
      <ReferenceInput source="company_id" reference="companies">
        <AutocompleteInput
          label={translate("tenax.rackets.fields.company_id")}
          optionText="name"
          helperText={false}
        />
      </ReferenceInput>
    </div>
  );
};

// Warning, not a block (D-031): the holder has no active discount code, so
// a purchase after the trial would not be attributed to it
export const NoReferralCodeWarning = ({
  contactId,
  companyId,
}: {
  contactId: number | null;
  companyId: number | null;
}) => {
  const translate = useTranslate();
  const filter =
    contactId != null
      ? { contact_id: contactId, active: true }
      : { company_id: companyId, active: true };
  const { data, isPending } = useGetList(
    "referral_codes",
    { pagination: { page: 1, perPage: 1 }, filter },
    { enabled: contactId != null || companyId != null },
  );
  if ((contactId == null && companyId == null) || isPending || data?.length) {
    return null;
  }
  return (
    <p
      role="status"
      className="flex items-center gap-2 text-sm text-amber-700 dark:text-amber-400"
    >
      <TriangleAlert className="size-4 shrink-0" />
      {translate("tenax.rackets.no_referral_code")}
    </p>
  );
};
